<template>
  <div v-if="value.ifLoad" @click="changeFilePreviewBackAudioPlay">
    <!-- 音频 -->
    <img style="width:20px;height:20px;" src="../../img/back_audio1.png"/>
    <audio v-if="value.ifLoad" ref="background_audio" :src="GLOBAL.getFileServeUrl()+value.audioUrl" autoplay="true"></audio>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_back_audio',
  props: {
    value: {
      type:Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  beforeDestroy(){
    
  },
  destroyed(){

  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
    //切换背景音频的播放事件
    changeFilePreviewBackAudioPlay:function(){
        var that = this;
        if(that.value.backGroundAudioPlayState) {
            this.$refs.background_audio.pause();
            that.value.backGroundAudioPlayState = false;
        } else {
            this.$refs.background_audio.play();
            that.value.backGroundAudioPlayState = true;
        }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
